import PropTypes from 'prop-types'
import React, { Fragment, useContext, useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { MenuContext } from './context/menuContext'
import styles from './MenuPrincipal.module.css'

const MENU_AYUDA = 70
const CONVERTIR_TIENDA_OFICIAL = 39
const POSICION_MENU_PRINCIPAL = 1
const POSICION_MENU_MOBILE = 4

const MenuPrincipal = (props) => {
  const navigate = useNavigate()
  const { menus, desplegarMenu, menuAbierto, nav } = useContext(MenuContext)
  const { loginDataContext: { tipoUsuario } = {} } = useAuth()
  const { isMobile } = useSelector((state) => state.clientData)
  const [idMenuAbrir, setMenuAbrir] = useState(0)
  const [subMenuAbierto, setSubMenuAbierto] = useState(false)

  // Reset submenu states when main menu closes
  useEffect(() => {
    if (!menuAbierto) {
      setMenuAbrir(0)
      setSubMenuAbierto(false)
    }
  }, [menuAbierto])

  useEffect(() => {
    if (!menuAbierto) return
    const handleClickOutside = (e) => {
      if (
        nav.current &&
        !nav.current.contains(e.target) &&
        !e.target.closest('[data-menu-toggle]')
      ) {
        desplegarMenu(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [menuAbierto, nav, desplegarMenu])

  const toggle = (idMenu) => {
    setMenuAbrir(idMenu)
    if (idMenu === idMenuAbrir) {
      setSubMenuAbierto(!subMenuAbierto)
    } else {
      setSubMenuAbierto(false)
    }
    if (idMenu === MENU_AYUDA) {
      props.mostrarAyuda()
    }
  }

  const handleMenuNavigation = () => {
    desplegarMenu(false)
  }

  return (
    <nav
      ref={nav}
      className={`${styles.verticalNav} ${styles.ocultarScroll} ${
        menuAbierto ? styles.verticalNavOpened : styles.verticalNavClosed
      }`}
    >
      <div className={styles.menuPanel}>
        <ul>
          {menus
            .filter(
              (menu) =>
                menu.idMenuPadre === 0 &&
                (menu.idMenuPosicion === POSICION_MENU_PRINCIPAL ||
                  (isMobile && menu.idMenuPosicion === POSICION_MENU_MOBILE))
            )
            .map((menuPrincipal) => (
              <Fragment key={menuPrincipal.idMenu}>
                <li
                  className={`${styles.asideMenuIcon} ${styles.menuDesplegarMenu}`}
                  id={menuPrincipal.idMenu}
                  onClick={() => {
                    if (menuPrincipal.link) {
                      if (menuPrincipal.idMenu === MENU_AYUDA) {
                        props.mostrarAyuda()
                      } else {
                        navigate(`/${menuPrincipal.link}`)
                        desplegarMenu(false)
                      }
                    } else {
                      toggle(menuPrincipal.idMenu)
                    }
                  }}
                >
                  {menuPrincipal.link && menuPrincipal.idMenu !== MENU_AYUDA ? (
                    <Link
                      to={`/${menuPrincipal.link}`}
                      onClick={(e) => {
                        e.stopPropagation()
                        handleMenuNavigation()
                      }}
                    >
                      <i className={`${menuPrincipal.icono} fa-fw`} aria-hidden="true" />
                      {menuPrincipal.nombre}
                    </Link>
                  ) : (
                    <>
                      <i className={`${menuPrincipal.icono} fa-fw`} aria-hidden="true" />
                      {menuPrincipal.idMenu === MENU_AYUDA ? (
                        <span className={styles.asideMenuIcon}>{menuPrincipal.nombre}</span>
                      ) : (
                        menuPrincipal.nombre
                      )}
                    </>
                  )}
                </li>

                {!menuPrincipal.link && menuPrincipal.idMenu === idMenuAbrir && !subMenuAbierto && (
                  <ul className={styles.subMenu}>
                    {menus
                      .filter((menuS) => {
                        if (menuS.idMenuPadre !== menuPrincipal.idMenu) return false
                        if (tipoUsuario === 'R' && menuS.idMenu === CONVERTIR_TIENDA_OFICIAL)
                          return false
                        return true
                      })
                      .map((subMenu) => (
                        <li key={subMenu.idMenu} id={subMenu.idMenu}>
                          <Link
                            to={`/${subMenu.link}`}
                            onClick={(e) => {
                              e.stopPropagation()
                              handleMenuNavigation()
                            }}
                          >
                            {subMenu.nombre}
                          </Link>
                        </li>
                      ))}
                  </ul>
                )}
              </Fragment>
            ))}
        </ul>
      </div>
    </nav>
  )
}

MenuPrincipal.propTypes = {
  mostrarAyuda: PropTypes.func.isRequired
}

export default React.memo(MenuPrincipal)
